import React, { useState, useEffect } from "react";
import { TESTIMONIALS } from "../mock";
import { Star, ChevronLeft, ChevronRight } from "lucide-react";

export default function TestimonialsPremium() {
  const [i, setI] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setI((v) => (v + 1) % TESTIMONIALS.length), 7000);
    return () => clearInterval(t);
  }, []);

  const t = TESTIMONIALS[i];
  const prev = () => setI((v) => (v - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
  const next = () => setI((v) => (v + 1) % TESTIMONIALS.length);

  return (
    <section className="bg-bone-2 py-24 lg:py-36 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-4 rv">
            <div className="text-eyebrow text-amber mb-5">— 004 • Reputation</div>
            <h2 className="font-display-tight text-5xl md:text-6xl leading-[0.95] text-ink text-balance">
              340+<br /><span className="italic font-display">five-star</span><br />reviews.
            </h2>
            <div className="flex items-center gap-2 mt-8">
              {[...Array(5)].map((_, k) => <Star key={k} className="w-5 h-5 text-amber" style={{ fill: "#b8864a" }} />)}
              <span className="ml-2 text-ink font-medium">4.9</span>
              <span className="text-ink-mute">on Google</span>
            </div>
          </div>

          <div className="lg:col-span-8 relative">
            <div className="font-display text-amber text-[160px] leading-[0.8] absolute -top-8 -left-4 opacity-40 pointer-events-none">&ldquo;</div>
            <div key={t.id} className="relative page-enter">
              <p className="font-display italic text-3xl md:text-5xl lg:text-[56px] leading-[1.15] text-ink max-w-3xl mb-12">
                {t.text}
              </p>
              <div className="flex items-center justify-between pt-8 border-t border-line">
                <div>
                  <div className="font-display text-2xl text-ink">{t.name}</div>
                  <div className="text-ink-soft text-sm">{t.role} — {t.project}</div>
                </div>
                <div className="flex items-center gap-3">
                  <button onClick={prev} className="h-12 w-12 border border-ink/20 flex items-center justify-center hover:bg-ink hover:text-bone transition-colors" aria-label="prev"><ChevronLeft className="w-4 h-4" /></button>
                  <span className="text-eyebrow text-ink/55 stat-num">{String(i + 1).padStart(2, "0")} / {String(TESTIMONIALS.length).padStart(2, "0")}</span>
                  <button onClick={next} className="h-12 w-12 border border-ink/20 flex items-center justify-center hover:bg-ink hover:text-bone transition-colors" aria-label="next"><ChevronRight className="w-4 h-4" /></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
